// Screenshot of the editor canvas at one moment of a scene — the evidence a Motion
// Director critique (MD v2 §5, explicit command only) sends. Seeks via
// seekEditorPlayhead, then html2canvas 0.5 (callback API, as GlobalConfig.jsx).
import html2canvas from "html2canvas";
import { seekEditorPlayhead } from "../../common/playhead_tracker";

const MAX_WIDTH = 1280;
const nextFrame = () => new Promise((resolve) => requestAnimationFrame(() => resolve()));

/** @returns {Promise<string|null>} JPEG data URL, or null on any failure. */
export async function captureSceneAt(navId, sec) {
  try {
    if (!(await seekEditorPlayhead(navId, sec))) return null;
    await nextFrame();
    await nextFrame();
    const el = document.getElementById("maincontent");
    if (!el) return null;
    const canvas = await new Promise((resolve) =>
      html2canvas(el, { useCORS: true, onrendered: resolve })
    );
    if (!canvas || !canvas.width) return null;
    const scale = Math.min(1, MAX_WIDTH / canvas.width);
    const out = document.createElement("canvas");
    out.width = Math.round(canvas.width * scale);
    out.height = Math.round(canvas.height * scale);
    out.getContext("2d").drawImage(canvas, 0, 0, out.width, out.height);
    return out.toDataURL("image/jpeg", 0.85);
  } catch (e) {
    return null;
  }
}
